import DocumentPreviewImage from "Areas/SharedFeatures/documentPreviewImage";
import noSelectedText from "Common/componentUtils/noSelectedText";
import { toTimeAgo } from "Common/dateTimeUtils/format";
import Menu from "Components/menu";
import { themeVariables } from "Components/theme";
import classNames from "classnames";
import compact from "lodash/compact";
import React, { useCallback, useMemo } from "react";
import locale from "./documentWithPreviewImage.locale";
import styles from "./documentWithPreviewImage.module.css";
const SIZES = {
    MENU_TOGGLER_SIZE: 26
};
export default function DocumentWithPreviewImage({ document, className, onOpenEditorPanel, onOpenDuplicatePanel, onDelete, canOpen, onOpen, width, height, canEdit, canDelete, canViewProjects }) {
    const canOpenDocument = canOpen && canOpen(document.Id, document.ProjectId);
    const menuItems = useMemo(() => compact([
        canOpenDocument && {
            text: locale.OPEN,
            onClick: () => {
                onOpen && onOpen(document.Id, document.ProjectId);
            }
        },
        canOpenDocument && {
            divider: true
        },
        canEdit &&
            canViewProjects && {
            text: locale.DUPLICATE,
            onClick: () => {
                document && onOpenDuplicatePanel && onOpenDuplicatePanel(document.Id);
            }
        },
        canEdit && {
            text: locale.EDIT,
            onClick: () => {
                document && onOpenEditorPanel && onOpenEditorPanel(document.Id);
            }
        },
        canDelete && {
            text: locale.DELETE,
            confirm: {
                title: locale.CONFIRM_DELETE_TEXT,
                header: locale.CONFIRM_DELETE_HEADER,
                callback: () => {
                    onDelete && onDelete(document.Id, document.ProjectId);
                }
            }
        }
    ]), [document, onOpen, onOpenEditorPanel, onOpenDuplicatePanel, onDelete]);
    const handleOpenDocument = useCallback(() => {
        if (canOpenDocument && noSelectedText())
            onOpen && onOpen(document.Id, document.ProjectId);
    }, [canOpenDocument, onOpen, document.Id, document.ProjectId]);
    const containerStyle = useMemo(() => ({
        background: themeVariables["document-card-bg"],
        border: `1px solid ${themeVariables["document-card-border-color"]}`,
        width,
        height
    }), [width, height]);
    return (React.createElement("div", { className: classNames("grid-rows-auto-1fr overflow-hidden border-rounded-medium", styles.card, className), style: containerStyle },
        React.createElement("div", { className: classNames("line-height-1 border-rounded-medium-top-left border-rounded-medium-top-right", canOpenDocument && "clickable"), onClick: handleOpenDocument },
            React.createElement(DocumentPreviewImage, { documentType: document.Type, width: width })),
        React.createElement("div", { className: classNames("caption-with-actions-panel", styles["project-actions"]) },
            React.createElement("div", { className: "overflow-hidden d-flex" },
                React.createElement("div", { className: classNames("ml-0_5 overflow-hidden", styles.text) },
                    React.createElement("div", { title: document.Name, className: classNames("w-100-max font-bold text-gray-600 text-overflow-ellipsis nowrap", canOpenDocument && "clickable", styles.name), onClick: handleOpenDocument }, document.Name),
                    React.createElement("div", { className: classNames("w-100-max font-h6 text-gray-300 text-overflow-ellipsis nowrap", styles.time) }, toTimeAgo(document.Updated)))),
            React.createElement(Menu, { togglerClassName: "menu-toggle-btn-text pt-0 pb-0", togglerHeight: SIZES.MENU_TOGGLER_SIZE, togglerWidth: SIZES.MENU_TOGGLER_SIZE, togglerIconClassName: "icon-dots menu-toggle-btn-text-icon", items: menuItems }))));
}
DocumentWithPreviewImage.defaultProps = {
    height: 147,
    width: 261
};
